import { render, staticRenderFns } from "./StickerChoice.vue?vue&type=template&id=80d59ee2&scoped=true&"
import script from "./StickerChoice.vue?vue&type=script&lang=ts&"
export * from "./StickerChoice.vue?vue&type=script&lang=ts&"
import style0 from "./StickerChoice.vue?vue&type=style&index=0&id=80d59ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d59ee2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
